<template>
<vx-card class='vx-col w-full mt-4'>
    <vs-tabs>
        <vs-tab label="Jugar">
            <Jugar />
        </vs-tab>
        <vs-tab label="Juegos">
            <ListaJuegoVue />
        </vs-tab>
        <vs-tab label="Tipos">
            <TiposGames />
        </vs-tab>
    </vs-tabs>
</vx-card>
</template>

<script>
import ListaJuegoVue from './listaJuego.vue';
import TiposGames from './tiposGames/lista.vue';
import Jugar from './presentar_juego/screen.vue';
export default {
    components: {
        ListaJuegoVue,
        TiposGames,
        Jugar,

    },
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>
